import DIApi from './_diApi';
import httpClient from '@/apis/base/httpclient';

class AccountParallelRuleAPI extends DIApi {
  constructor() {
    super();
  }
  controllerName = 'AccountParallelRules';
  /**
   * Add and Update multiple
   * HTHAI 07.06.2022
   */
  addAndUpdateMultiple(param) {
    let request = {
      url: this.getAPIUrl() + '/AddAndUpdateMultiple',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * overwrite data
   * nmtuan4 16.7.20222
   */
  overwrite(param) {
    let request = {
      url: this.getAPIUrl() + '/Overwrite',
      data: param,
    };

    return httpClient.postAsync(request);
  }

  /**
   * overwrite data
   * nmtuan4 16.7.20222
   */
  default(param) {
    let request = {
      url: this.getAPIUrl() + '/default',
      data: param,
    };

    return httpClient.getAsync(request);
  }
  /**
   * Lấy dữ liệu danh sách full
   */
  getFullListCache(payload) {
    let request = {
      url: this.getAPIUrl() + '/full',
      data: payload
    };

    return httpClient.getAsync(request);
  }
}

export default new AccountParallelRuleAPI();
